import './scss/index.scss';
import { dcFactory } from 'dc';
import MiniBasketComponent from './js/mini-basket.component';

dcFactory.register(MiniBasketComponent);
